import { UploadResult } from 'LuxuryInvitation-Types';
import { ApiClient } from '@travel/api-client';

export const ApiUploadFile = (http: ApiClient, formData: FormData) => {
  return http
    .post(`/consumer/member/internal/members/import`, { values: formData })
    .then((data: UploadResult) => data)
    .catch((data: UploadResult) => data);
};
